import { Component, OnInit } from '@angular/core';
import { Subject } from 'rxjs';
import { SwitchFolderAsUnreadActionData } from 'src/app/components/designer/models/switch-folder-as-unread-action-data';
import { FormMode } from '../../common/form-mode';
import { ContextualMenuEvent } from '../contextual-menu-event';
import { WorkflowDataInterface } from '../workflow-data.interface';

@Component({
    selector: 'app-workflow-action-switch-folder-as-unread-data',
    imports: [],
    templateUrl: './workflow-action-switch-folder-as-unread-data.component.html',
    styleUrl: './workflow-action-switch-folder-as-unread-data.component.scss'
})
export class WorkflowActionSwitchFolderAsUnreadDataComponent implements WorkflowDataInterface, OnInit {
    /**
     * Données affichées par le composant dynamique.
     */
    public _data: SwitchFolderAsUnreadActionData;

    /**
     * Spécifie les données affichées par le composant dynamique.
     */
    set data(value: string | SwitchFolderAsUnreadActionData) {
        if (typeof value === 'string') {
            this._data = JSON.parse(value);
        } else {
            this._data = value as SwitchFolderAsUnreadActionData;
        }
    }

    /**
     * Obtient les données affichées par le composant dynamique.
     */
    get data(): SwitchFolderAsUnreadActionData {
        this._data = new SwitchFolderAsUnreadActionData();
        return this._data;
    }

    /**
     * Mode d'affichage du formulaire.
     */
    mode: FormMode;

    /**
     * Retourne une valeur indiquant si l'utilisateur a modifié des valeurs du formulaire.
     */
    public get dirty(): boolean {
        return false;
    }

    /**
     * Source du menu contextuel.
     */
    contextualMenuSource: Subject<ContextualMenuEvent> = new Subject<ContextualMenuEvent>();

    /**
     * Constructeur.
     */
    constructor() {}

    /**
     * Appellé lors de l'initialisation du contrôle.
     */
    ngOnInit(): void {}

    /**
     * Indique si le formulaire est valide.
     */
    public isValid(): boolean {
        return true;
    }

    /**
     * Annulle les changements effectués par l'utilisateur.
     */
    public clearData() {}
}
